import { useMemo } from "react";
import { decodeHtmlEntities } from "./common-utils";

export function useDecodeHtml(text: string | undefined | null): string {
  return useMemo(() => {
    if (!text) return "";
    return decodeHtmlEntities(text);
  }, [text]);
}
